import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AuthBaseService, PageVisibilityComponent } from '@rp/core';
import { IconService } from '@rp/shared/services';

@Component({
  selector: 'rp-root',
  standalone: true,
  templateUrl: './app.component.html',
  imports: [RouterOutlet],
  providers: [IconService],
})
export class AppComponent extends PageVisibilityComponent implements OnInit {
  private _iconService = inject(IconService);

  constructor(authService: AuthBaseService) {
    super(authService);
  }

  ngOnInit(): void {
    this._iconService.registerIcons();
  }
}
